import { Link } from 'react-router-dom'

import { styled } from 'styled-system/jsx'

const Section = styled('section', {
  base: {
    backgroundColor: '#FFFFFF',
    borderRadius: 'lg',
    padding: '20px 22px',
    boxShadow: '0 12px 32px -22px rgba(128, 84, 255, 0.18)',
    display: 'flex',
    flexDirection: 'column',
    gap: '14px',
  },
})

const SectionHeader = styled('div', {
  base: {
    display: 'flex',
    alignItems: 'baseline',
    justifyContent: 'space-between',
    gap: '12px',
    flexWrap: 'wrap',
  },
})

const Title = styled('h2', {
  base: {
    fontFamily: 'display',
    fontSize: '17px',
    fontWeight: '700',
    color: 'quickpass.ink',
    margin: '0',
    letterSpacing: '-0.2px',
  },
})

const Stamp = styled('span', {
  base: {
    fontFamily: 'body',
    fontSize: '12px',
    color: 'quickpass.inkSoft',
  },
})

const FeedList = styled('ul', {
  base: {
    listStyle: 'none',
    padding: '0',
    margin: '0',
    display: 'flex',
    flexDirection: 'column',
    gap: '0',
    position: 'relative',
  },
})

const Row = styled('li', {
  base: {
    display: 'grid',
    gridTemplateColumns: '36px 1fr',
    gap: '14px',
    paddingY: '12px',
    borderBottom: '1px solid',
    borderColor: '#F8F6FF',
    cursor: 'pointer',
    transition: 'background-color {durations.fast} {easings.appleStandard}',
    _hover: {
      backgroundColor: 'quickpass.surfaceCool',
    },
    _last: {
      borderBottom: 'none',
    },
  },
})

const Glyph = styled('span', {
  base: {
    width: '36px',
    height: '36px',
    borderRadius: 'pill',
    backgroundColor: 'quickpass.surfaceCool',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '16px',
    flexShrink: '0',
  },
})

const Body = styled('div', {
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: '2px',
    minWidth: '0',
  },
})

const RowHeader = styled('div', {
  base: {
    display: 'flex',
    alignItems: 'baseline',
    justifyContent: 'space-between',
    gap: '10px',
  },
})

const RowTitle = styled('span', {
  base: {
    fontFamily: 'display',
    fontSize: '14px',
    fontWeight: '700',
    color: 'quickpass.ink',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    minWidth: '0',
  },
})

const RowTime = styled('span', {
  base: {
    fontFamily: 'body',
    fontSize: '11px',
    fontWeight: '600',
    color: 'quickpass.inkSoft',
    flexShrink: '0',
  },
})

const RowText = styled('p', {
  base: {
    fontFamily: 'body',
    fontSize: '13px',
    color: 'quickpass.inkSoft',
    margin: '0',
    lineHeight: '1.45',
    lineClamp: '2',
  },
})

const EmptyBlock = styled('div', {
  base: {
    paddingX: '16px',
    paddingY: '24px',
    textAlign: 'center',
    fontFamily: 'body',
    fontSize: '13px',
    color: 'quickpass.inkSoft',
    fontStyle: 'italic',
  },
})

const ViewAllLink = styled(Link, {
  base: {
    fontFamily: 'body',
    fontSize: '12px',
    fontWeight: '700',
    color: 'quickpass.primary',
    textDecoration: 'none',
    cursor: 'pointer',
    _hover: {
      textDecoration: 'underline',
      textUnderlineOffset: '3px',
    },
  },
})

export {
  Section,
  SectionHeader,
  Title,
  Stamp,
  FeedList,
  Row,
  Glyph,
  Body,
  RowHeader,
  RowTitle,
  RowTime,
  RowText,
  EmptyBlock,
  ViewAllLink,
}
